/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, TextField, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    Apartment,
    Flag,
    PhoneAndroidOutlined,
    PlaceOutlined,
    StorefrontOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {obtenerDepartamentos} from "../../Modulo_Graficas/Graficas/Componentes/Mapa/Funciones/obtenerDepartamentos";
import {obtenerCiudades} from "../../Modulo_Graficas/Graficas/Componentes/Mapa/Funciones/obtenerCiudades";
import {useEffect, useState} from "react";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Cliente = ({...props}) => {
    const [departamento, setDepartamento] = useState('')


    useEffect(() => {

        let dep = props.props.getValues('departamento')
        setDepartamento(dep)

    }, [props.props.watch('departamento')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Datos del Negocio</Typography>
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} ancho={2} alto={1}/>
                </Grid2>


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre Completo'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={StorefrontOutlined} nombre={'Razon Social'} dato={'razon'} {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Datos de ubicacion</Typography>
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Departamento'} dato={'departamento'}
                                   opciones={obtenerDepartamentos()}
                                   {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Apartment} nombre={'Ciudad'} dato={'ciudad'}
                                   opciones={obtenerCiudades(departamento)}
                                   {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={StorefrontOutlined} nombre={'Direccion'} dato={'direccion'} {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Celular 1'} dato={'celularUno'} {...props}
                                  type={'phone'}
                    />
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Celular 2'} dato={'celularDos'} {...props}
                                  type={'phone'}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Datos geograficos</Typography>
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={PlaceOutlined} nombre={'Latitud'} dato={'latitud'} {...props}
                                  type={'number'}
                    />
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={PlaceOutlined} nombre={'Longitud'} dato={'longitud'} {...props}
                                  type={'number'}
                    />
                </Grid2>


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <TextField rows={10}
                               slotProps={{
                                   input: {

                                       disableUnderline: true,
                                   }
                               }
                               }
                    />
                </Grid2>


            </Grid2>

        </form>

    )

}
export default Formulario_Cliente